import React from 'react'

import './SectionTitle.scss'

export default function SectionTitle(props) {
    return (
        <div className={`section-title ${props.noMargins ? 'no_margins' : ''}`}>
            <span>{props.title}</span>
            {props.children}
        </div>
    )
}
